export default "__VITE_ASSET__BSbI_kEV__"